if (!customElements.get('restock-notify')) {
  customElements.define(
    'restock-notify',
    class RestockNotify extends HTMLElement {
      connectedCallback() {
        this.variantInput = this.querySelector('[data-restock-variant]');
        this.onlySoldOut = this.dataset.onlySoldOut === 'true';
        this.replaceBuyButton = this.dataset.replaceBuyButton === 'true';
        this.forceOpen = Boolean(this.querySelector('[data-restock-open]'));
        this.opened = this.forceOpen;

        if (this.replaceBuyButton) this.watchBuyButton();

        if (typeof subscribe !== 'function') return;
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.section) return;
          if (this.variantInput) this.variantInput.value = event.data.variant ? event.data.variant.title : '';
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
        if (this.buttonObserver) this.buttonObserver.disconnect();
        if (this.trigger) this.trigger.remove();
      }

      watchBuyButton() {
        this.submitButton = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        const template = this.querySelector('[data-restock-trigger-template]');
        if (!this.submitButton || !template) return;

        this.trigger = template.content.firstElementChild.cloneNode(true);
        this.trigger.setAttribute('aria-controls', this.id);
        this.trigger.addEventListener('click', () => this.toggleOpen());
        this.submitButton.after(this.trigger);

        this.buttonObserver = new MutationObserver(() => this.update());
        this.buttonObserver.observe(this.submitButton, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });
        this.update();
      }

      isSoldOut() {
        if (!this.submitButton.hasAttribute('disabled')) return false;

        // The button is also disabled briefly while a variant change is loading,
        // so only treat it as sold out when it shows the sold out / unavailable label.
        const label = this.submitButton.textContent.trim().toLowerCase();
        const strings = window.variantStrings || {};
        return [strings.soldOut, strings.unavailable].some((text) => text && label === text.toLowerCase());
      }

      toggleOpen() {
        this.opened = !this.opened;
        this.forceOpen = false;
        this.update();

        if (!this.opened) return;
        const email = this.querySelector('input[type="email"]');
        this.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        if (email) email.focus({ preventScroll: true });
      }

      update() {
        const soldOut = this.isSoldOut();

        this.submitButton.classList.toggle('restock-notify-hidden', soldOut);
        this.trigger.classList.toggle('hidden', !soldOut);
        this.trigger.setAttribute('aria-expanded', String(soldOut && this.opened));

        // After submitting, the page reloads on the first available variant, so keep the
        // success / error message visible regardless of the selected variant.
        this.classList.toggle('hidden', !this.forceOpen && (!soldOut || !this.opened));
      }
    }
  );
}
